import React from 'react'

export default function AdminUnitStatPage() {
    return (
        <div>AdminUnitStatPage</div>
    )
}
